import { useContext } from "react";
import SliderContext from "../../components/sliderContext";
import AboutHeading from "../../images/about-us/about-heading.png";
import Linkedin from "../../images/about-us/linkedin.png";
import Profile from "../../images/about-us/profile.png";

function Leadership() {
  const { setSliderOpen } = useContext(SliderContext);
  const { setSliderValue } = useContext(SliderContext);

  return (
    <div className="about-us-leadership">
      <div className="heading">
        <img src={AboutHeading} alt="bg" />
        <h1>Our Leadership</h1>
        <p>
          Founded in 2013,{" "}
          <span style={{ fontWeight: "bold" }}>BrandOne Technologies Ltd</span>{" "}
          is a notable provider of vendor-independent enterprise solutions. We
          help businesses translate their goals into effective IT services,
          using our proprietary project management framework and tools to
          maximize ROI. With over 15 years of hands-on experience, our certified
          professionals bring deep expertise in enterprise application design,
          system integration, and customer service. We identified a gap in
          enterprise web solutions — and we're filling it with smart, reliable
          delivery. Built on trust, quality, and strong relationships, we value
          openness, collaboration, and delivering real value to every client.
        </p>
      </div>
      <div className="image1">
        <div className="name-card">
          <h2>Salisu A. Abdullahi</h2>
          <p>Chairman, Board of Directors</p>
        </div>
        <div className="link-card">
          <img className="linkedin" src={Linkedin} alt="link" />
          <img
            className="profile"
            src={Profile}
            alt="link"
            onClick={() => {
              setSliderOpen(true);
              setSliderValue("salisu");
            }}
          />
        </div>
      </div>
      <div className="image2">
        <div className="name-card">
          <h2>Samuel Anyanwu</h2>
          <p>Managing Director & Co-founder</p>
        </div>
        <div className="link-card">
          <img className="linkedin" src={Linkedin} alt="link" />
          <img
            className="profile"
            src={Profile}
            alt="link"
            onClick={() => {
              setSliderOpen(true);
              setSliderValue("sam");
            }}
          />
        </div>
      </div>
      <div className="image3">
        <div className="name-card">
          <h2>Russell Duru</h2>
          <p>Deputy Managing Director & Co-founder</p>
        </div>
        <div className="link-card">
          <img className="linkedin" src={Linkedin} alt="link" />
          <img
            className="profile"
            src={Profile}
            alt="link"
            onClick={() => {
              setSliderOpen(true);
              setSliderValue("russell");
            }}
          />
        </div>
      </div>
      <div className="image4">
        <div className="name-card">
          <h2>Damilare Olanrewaju</h2>
          <p>Chief Technology Officer</p>
        </div>
        <div className="link-card">
          <img className="linkedin" src={Linkedin} alt="link" />
        </div>
      </div>
      <div className="image5">
        <div className="name-card">
          <h2>Kayang Albert</h2>
          <p>Human Resources Manager</p>
        </div>
        <div className="link-card">
          <img className="linkedin" src={Linkedin} alt="link" />
        </div>
      </div>
      <div className="image6">
        <div className="name-card">
          <h2>Ekene Ezeweputa</h2>
          <p>Business Development Manager</p>
        </div>
        <div className="link-card">
          <img className="linkedin" src={Linkedin} alt="link" />
        </div>
      </div>
      <div className="image7">
        <div className="name-card">
          <h2>Ibukun Fayanjuola</h2>
          <p>Project Manager</p>
        </div>
        <div className="link-card">
          <img className="linkedin" src={Linkedin} alt="link" />
        </div>
      </div>
    </div>
  );
}

export default Leadership;
